import { render, staticRenderFns } from "./AutomacaoSubmenu.vue?vue&type=template&id=72e84b32"
import script from "./AutomacaoSubmenu.vue?vue&type=script&lang=js"
export * from "./AutomacaoSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports